export const EMPLOYEE_FORM_GROUP_KEYS = Object.freeze({
  status: 'status',
  firstName: 'firstName',
  lastName: 'lastName',
  companyId: ['company', '_id'],
  employeeSector: ['employeeSector', '_id'],
  generalData: {
    email: ['generalData', 'email'],
    personalNumber: ['generalData', 'personalNumber'],
    phone: ['generalData', 'phone'],
    country: ['generalData', 'country'],
    address: ['generalData', 'address'],
    city: ['generalData', 'city'],
    municipality: ['generalData', 'municipality'],
    position: ['generalData', 'position'],
    positionEng: ['generalData', 'positionEng'],
    jobPosition: ['generalData', 'jobPosition'],
    orgUnit: ['generalData', 'orgUnit'],
    otherRemarks: ['generalData', 'otherRemarks'],
    bankAccounts: ['generalData', 'bankAccounts'],
    bankName: ['generalData', 'bankName'],
    isResident: ['generalData', 'isResident'],
  },
  otherAllowances: {
    bonusBasis: ['otherAllowances', 'bonusBasis'],
  },
  employmentSettings: {
    startDate: ['employmentSettings', 'startDate'],
    endDate: ['employmentSettings', 'endDate'],
    workTimeCustomType: ['employmentSettings', 'workTimeCustomType'],
    workTimeType: ['employmentSettings', 'workTimeType'],
    employmentType: ['employmentSettings', 'employmentType'],
    isHrOfficer: ['employmentSettings', 'isHrOfficer'],
    shiftWorker: ['employmentSettings', 'shiftWorker'],
    dateOfWorkPermissionForeigner: [
      'employmentSettings',
      'dateOfWorkPermissionForeigner',
    ],
  },
  holidayLeaveCalculation: {
    numberOfHolidayDaysPast: [
      'holidayLeaveCalculation',
      'numberOfHolidayDaysPast',
    ],
    numberOfHolidayDaysUsed: [
      'holidayLeaveCalculation',
      'numberOfHolidayDaysUsed',
    ],
    numberOfHolidayDaysContract: [
      'holidayLeaveCalculation',
      'numberOfHolidayDaysContract',
    ],
    employeeTrackerType: ['holidayLeaveCalculation', 'employeeTrackerType'],
  },
  additionalPersonalInfo: {
    birthDate: ['additionalPersonalInfo', 'birthDate'],
    placeOfBirth: ['additionalPersonalInfo', 'placeOfBirth'],
    gender: ['additionalPersonalInfo', 'gender'],
    familyCelebrationDate: ['additionalPersonalInfo', 'familyCelebrationDate'],
    previousEmployments: ['additionalPersonalInfo', 'previousEmployments'],
    workExperience: ['additionalPersonalInfo', 'workExperience'],
    workExperienceStartDate: [
      'additionalPersonalInfo',
      'workExperienceStartDate',
    ],
    maritalStatus: ['additionalPersonalInfo', 'maritalStatus'],
    children: ['additionalPersonalInfo', 'children'],
    educationLevel: ['additionalPersonalInfo', 'educationLevel'],
    educationLevelOther: ['additionalPersonalInfo', 'educationLevelOther'],
  },
});

export const EMPLOYEE_GENERAL_DATA_FORM = Object.freeze({
  firstName: undefined,
  lastName: undefined,
  status: undefined,

  employeeSector: undefined,

  company: {
    _id: undefined,
  },

  generalData: {
    personalNumber: undefined,
    email: undefined,
    position: undefined,
    positionEng: undefined,
    jobPosition: undefined,
    orgUnit: undefined,
    phone: undefined,
    gender: undefined,
    country: undefined,
    city: undefined,
    municipality: undefined,
    zip: undefined,
    address: undefined,
    bankAccounts: { part1: undefined, part2: undefined, part3: undefined },
    bankName: undefined,
    isResident: true,
    otherRemarks: undefined,
  },

  employmentSettings: {
    startDate: undefined,
    endDate: undefined,
    employmentType: 'unlimited',
    workTimeType: 'fullTime',
    workTimeCustomType: undefined,
    isHrOfficer: false,
    shiftWorker: false,
    locked: false,
    stoppedWithWork: false,
    dateOfWorkPermissionForeigner: undefined,
  },

  allowances: {
    mealAllowance: 0,
    holidayAllowance: 0,
    travelAllowance: 0,
    workFromHomeAllowance: 0,
    defaultTimesheetComment: '',
  },

  otherAllowances: {
    otherIncome: 0,
    otherExpenses: 0,
    suspension: 0,
    bonus: 0,
    bonusBasis: 'company',
    bonusVariations: {},
    suspensionVariations: {},
    nonMonetaryBenefit: 0,
    nonMonetaryBenefitVariations: {},
  },

  holidayLeaveCalculation: {
    // ! IMPORTANT: holidayDaysYear
    numberOfHolidayDays: 0,
    numberOfHolidayDaysPast: 0,
    numberOfHolidayDaysCurrent: 0,
    numberOfHolidayDaysContract: 0,
    numberOfHolidayDaysByEndOfContract: null,
    numberOfHolidayDaysUsed: 0,
    employeeTrackerType: 'new',
  },

  careerHistory: {},

  suspensionDrawer: {
    editedReasonOfSuspension: undefined,
    editedReasonOfSuspensionEng: undefined,
    suspensionAmount: undefined,
    currencySuspension: undefined,
    dateOfCreation: undefined,
  },

  additionalPersonalInfo: {
    birthDate: undefined,
    placeOfBirth: undefined,
    gender: undefined,
    familyCelebrationDate: undefined,
    previousEmployments: [],
    workExperience: {
      years: undefined,
      months: undefined,
      days: undefined,
    },
    workExperienceStartDate: undefined,
    maritalStatus: undefined,
    children: [],
    educationLevel: undefined,
    educationLevelOther: undefined,
  },

  attachments: {
    typeOfFile: undefined,
    location: undefined,
    originalName: undefined,
  },
});
